//Staging API
// const baseUrl = "https://api-staging.e-citizen.ng/api/v2";
// const imageBaseUrl = "https://api-staging.e-citizen.ng";

//Prod API
const baseUrl = "https://api.e-citizen.ng/api/v2";
const imageBaseUrl = "https://api.e-citizen.ng";

// ─── Analytics Master Kill-Switch ────────────────────────────────────────────
// Set to true  → all GA4 events and Facebook Pixel events fire normally.
// Set to false → ALL tracking is silently disabled (no gtag, no fbq, nothing).
// This overrides every other analytics flag in the app.
export const ANALYTICS_MASTER_ENABLED = true;
// ─────────────────────────────────────────────────────────────────────────────

export default baseUrl;
export { imageBaseUrl };
